<script setup lang="ts">
import { computed } from 'vue';
import type { Icon } from '../HugeIcon/huge-icon';
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import { ICON_TAG_VARIANT_CLASSES, type IconTagVariant } from './icon-tag';

const props = withDefaults(
  defineProps<{
    icon: Icon;
    count?: number;
    label?: string;
    text?: string;
    variant?: IconTagVariant;
  }>(),
  {
    variant: 'default',
  },
);

const tagClasses = computed(
  () =>
    `flex items-center gap-1 rounded-lg border px-2 py-0 text-sm font-medium ${ICON_TAG_VARIANT_CLASSES[props.variant]}`,
);
</script>

<template>
  <label :class="tagClasses">
    <HugeIcon :icon="props.icon" :size="16" />
    <span v-if="props.text">{{ props.text }}</span>
    <span v-else
      >{{ props.count
      }}<template v-if="props.label">&nbsp;{{ props.label }}</template></span
    >
  </label>
</template>
